<template>
  <a class="underline text-gray-500 hover:text-gray-200 text-sm cursor-pointer"><slot /></a>
</template>
